<template>
  <div :id="id" class="chart-body" :style="{height: height + 'px'}"></div>
</template>

<script>
  import echarts from 'echarts'
  import  'echarts/theme/macarons.js'
  import  wonderlandTheme from './js/wonderland'

  import option from './js/option'
  import dimensions from './js/dimensions'
  import yAxisOption from './js/yAxisOption'
  import yAxisOptionCompare from './js/yAxisOptionCompare'
  import seriesOption from './js/seriesOption'
  import seriesOptionCompare from './js/seriesOptionCompare'

  export default {
    props: {
      id: String,
      height: Number,
      compare: Boolean,
      xdata: Array,
      ydata: Array,
      seriesOption: Array
    },
    data: function () {
      return {
        chart: null,
      }
    },
    computed: {
      option: function () {
        let o = { ...option };
        let xdata = this.xdata || [];
        let ydata = this.ydata || [];
        let legendData = [];
        let seriesArr = [];
        let yAxisArr = [];
        let xAxisArr = [];
        let gridArr = [];
        let xItem = {
          type: 'category',
          axisPointer: {
            type: 'shadow'
          }
        };
        if (this.compare) {
          xAxisArr.push({ ...xItem, data: xdata[0] });
          xAxisArr.push({ ...xItem, offset: this.height * -1 + 65, data: xdata[1] });
        } else {
          xAxisArr.push({ ...xItem, data: xdata });
        }
        o.xAxis = xAxisArr;

        let idx = 0;
        for(let item of ydata) {
          let value = item.value;
          value = value.map(t => t == 'Infinity' || isNaN(t) ? null : t);
          let max = Math.max.apply(null, value.filter(t => !isNaN(t)));
          let dimension = dimensions[item.name] || {};
          let seriesName = item.label || dimension.name || item.name;
          let yOption = this.compare ? yAxisOptionCompare : yAxisOption;
          let seriesOptions = this.seriesOption || (this.compare ? seriesOptionCompare : seriesOption);

          let series = {
            name: seriesName,
            yAxisIndex: idx,
            data: value,
            ...seriesOptions[idx]
          };
          let yAxis = {
            name: seriesName,
            ...yOption[idx],
            min: 0,
            max: parseInt(max * 1.3) + 1,
            axisLabel: {
              margin: 2
            }
          };
         let grid = {
            left: 140,
            right: 140
          };
          legendData.push(seriesName);
          seriesArr.push(series);
          yAxisArr.push(yAxis);
          gridArr.push(grid);
          idx++;
          if (idx >= 4) {
            break;
          }
        }
        o.series = seriesArr;
        o.yAxis = yAxisArr;
        o.grid = gridArr;
        o.legend.data = legendData;
        return o;
      }
    },
    mounted: function () {
      wonderlandTheme(echarts);
      this.chart = echarts.init(document.getElementById(this.id), 'wonderland');
      window.addEventListener('resize', this.chart.resize);

      this.$watch('show', this.chart.resize);
      this.$watch('option', this.init, { deep: true });
      this.init();
    },
    destroyed: function() {
      window.removeEventListener('resize', this.chart.resize);
    },
    methods: {
      init: function () {
        let {series, xAxis} = this.option;
        if (!series || series.length == 0 || !xAxis || xAxis.length == 0 ) {
          return;
        }
        this.chart.clear();
        if (this.ydata.map(t => t.value).filter(t => t.length > 0).length === 0) {
          this.chart.showLoading({
            text: '暂无数据',
            color: '#ffffff',
            textColor: '#8a8e91',
            fontsize: '20px',
            maskColor: 'rgba(255, 255, 255, 0.8)',
          });
        } else {
          this.chart.hideLoading();
        }
        this.chart.setOption(this.option);
      },
      clear: function () {
        this.chart.clear();
      }
    },
  }
</script>